<div [hidden]="!logoSrc">
    <div  class="image-container flex items-center" [ngClass]="imagePosition">
        <figure>
            <img *ngIf="logoSrc" [src]="logoSrc">
        </figure> 
    </div>
</div>
